export class EacItem {
    public name: string;
    public years: number[];

    constructor(name, fee) {
        this.name = name;
        this.years = [fee, fee, fee, fee];
    }
}
